/**
 * parameters to send to capa
 */
export const CAPA_CONSTANTS = {
    idMagento: "1",
    timestamp: "1",
};
